import type { ChatSlotRenderers } from '../chat';
import { JobProfileIdleBadge } from './job-profile-section/JobProfileIdleBadge';
import { JobProfileReviewPrompt } from './job-profile-section/JobProfileReviewPrompt';

// Chat composer slot content for job-profile chat contexts, registered with
// the chat module via app/chat-slot-registry.ts.
export const jobArchitectureChatSlotRenderers: ChatSlotRenderers = {
    idleSlot: (context) =>
        context.kind === 'job-profile' ? (
            <JobProfileIdleBadge
                architectureId={context.architectureId}
                itemId={context.itemId}
                itemType={context.itemType}
                version={context.version}
            />
        ) : undefined,
    prompt: (context) =>
        context.kind === 'job-profile' ? (
            <JobProfileReviewPrompt
                architectureId={context.architectureId}
                itemId={context.itemId}
                itemType={context.itemType}
                preferredLanguage={context.preferredLanguage}
                version={context.version}
            />
        ) : undefined,
};
